import {
  facebookIcon,
  instagramIcon,
  twitterIcon,
  linkedIcon,
  clientFirst,
  clientSecond,
  clientThird,
  clientFourth,
  clientFifth,
  clientSixth,
  slideOne,
  slideTwo,
  slideThree,
  slideOFour,
  slideFive,
  PinterestIcon,
} from "../assets";

export const navbarData = [
  {
    class: "home",
    label: "home",
    path: "/",
  },
  {
    class: "about",
    label: "about us",
    path: "/about-us",
  },
  {
    class: "service",
    label: "services",
    path: "/service",
  },
  {
    class: "blog",
    label: "blogs",
    path: "/blogs",
  },
  {
    class: "contact",
    label: "contact",
    path: "/contact-us",
  },
];

export const socialData = [
  {
    href: "https://www.facebook.com/Rozisoft/",
    icon: facebookIcon,
  },
  {
    href: "https://instagram.com/rozi.soft?igshid=OGQ5ZDc2ODk2ZA==",
    icon: instagramIcon,
  },
  {
    href: "https://www.youtube.com/@rozisoft",
    icon: twitterIcon,
  },
  {
    href: "https://www.linkedin.com/in/rozi-soft/",
    icon: linkedIcon,
  },
  {
    href: "https://www.pinterest.com/Rozisoftpk/",
    icon: PinterestIcon,
  },
];

export const homeData = [
  slideOne,
  slideTwo,
  slideThree,
  slideOFour,
  slideFive,
];

export const aboutData = [
  {
    paragraph:
      "ROZISOFT is a digital marketing agency in Pakistan. We've been helping businesses grow using expert digital marketing strategies and services for many years. We serve clients all over the world and have completed many successful digital marketing projects. Our team includes experts in SEO, social media marketing, pay-per-click advertising, web development, design, content creation, and digital strategy. Compared  to other digital service providers in Pakistan, we have a strong portfolio with excellentresults, revenue generation, ROI, and brand building for businesses in Pakistan and worldwide.",
  },
  {
    paragraph:
      "We create customized strategies using AI technology and stay updated with the latest algorithms to ensure a return on investment for our partners. Our portfolio shows how we've boosted exposure, traffic, sales, conversions, engagement, and brand awareness to levels that every forward-thinking business aims for. Our team is dedicated to staying on top of the ever-changing digital landscape.",
  },
];

export const clientData = [
  {
    imgSrc: clientFirst,
  },
  {
    imgSrc: clientSecond,
  },
  {
    imgSrc: clientThird,
  },
  {
    imgSrc: clientFourth,
  },
  {
    imgSrc: clientFifth,
  },
  {
    imgSrc: clientSixth,
  },
];
